import { styled } from '@mui/material/styles';

import { GenericTable } from 'components/Table';

import { InventoryCustomAction } from 'constants/enums';

interface StyledInventoryActionDataGridProps {
  customAction: InventoryCustomAction;
}

export const StyledInventoryActionDataGrid = styled(GenericTable, {
  shouldForwardProp: (prop) => prop !== 'customAction',
})<StyledInventoryActionDataGridProps>(({ customAction }) => {
  switch (customAction) {
    case InventoryCustomAction.ADJUST:
      return {
        '& .MuiDataGrid-cell[data-field="actualQuantity"]': {
          padding: 0,
        },
      };
    case InventoryCustomAction.MOVE:
      return {
        '& .MuiDataGrid-cell[data-field="moveQuantity"]': {
          padding: 0,
        },
      };
    default:
      return {};
  }
});
